import React from 'react';
import './footer.css';
import {
  FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube,
  FaLocationDot, FaPhone, FaEnvelope, FaRegLightbulb
} from "react-icons/fa6";
import { Link } from 'react-router-dom';
import logo from '../assets/images/fintechsmart_Logo.png';
import { FintechSmartSolutions, BrandLogo } from './FintechSmartSolutions';

const Footer = () => {
  return (
    <footer className="ambient-footer-section">
      <div className="container ambient-footer-container">
        <div className="ambient-footer-grid">

          <div className="ambient-footer-col logo-brand-section">
            <BrandLogo src={logo} alt="Fintech Smart Solutions Logo" className="ambient-footer-logo" />
            <p className="ambient-footer-tagline">
              Empowering India&apos;s Workforce with Smarter, Faster Lending.
            </p>
            <p className="ambient-footer-text">
              We leverage technology to deliver timely, trusted, and efficient credit solutions for India&apos;s salaried professionals.
            </p>

            <div className="ambient-footer-social">
              <a href="https://www.facebook.com/people/Fintech-Smart-Solutions/61584429561935/" className="social-amb-icon" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/fintechsmartsolutions/" className="social-amb-icon" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="https://www.instagram.com/fintech_smart_solutions/" className="social-amb-icon" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.youtube.com/@Fintechsmartsolutions" className="social-amb-icon" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          <div className="ambient-footer-col links-section">
            <h4 className="footer-amb-heading"><FaRegLightbulb className="heading-amb-icon" /> Quick Links</h4>
            <ul className="footer-amb-links-list">
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
            </ul>
          </div>

          <div className="ambient-footer-col contact-amb-info-block">
            <h4 className="footer-amb-heading">Get In Touch</h4>
            <div className="contact-amb-item">
              <FaLocationDot className="contact-amb-icon" />
              <p>Office Space No. D-6, 1st and 2nd Floor, Sector 2, Noida, Uttar Pradesh, India</p>
            </div>
            <div className="contact-amb-item">
              <FaEnvelope className="contact-amb-icon" />
              <a href="mailto:info@fintechsmartsolutions.com">info@fintechsmartsolutions.com</a>
            </div>
            <div className="contact-amb-item">
              <FaPhone className="contact-amb-icon" />
              <a href="tel:+919560089567">+91-9560089567</a>
            </div>
          </div>
        </div>

        <div className="ambient-footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} <FintechSmartSolutions />. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
